import React from 'react';
import { Section } from '../../types/Section';
import { SectionContainer } from './SectionContainer';
import { FileText, Download } from 'lucide-react';

interface FilesSectionProps {
    section: Section;
}

export const FilesSection: React.FC<FilesSectionProps> = ({ section }) => {
    // Mock file data - would come from the API in real implementation
    const mockFiles = [
        { name: 'Event Schedule.pdf', size: '2.4 MB', url: '#' },
        { name: 'Speaker Biographies.pdf', size: '1.8 MB', url: '#' },
        { name: 'Venue Map.pdf', size: '1.2 MB', url: '#' },
    ];

    return (
        <SectionContainer section={section}>
            <h2 className="text-2xl font-bold mb-6">{section.title}</h2>
            <div className="space-y-3">
                {mockFiles.map((file, index) => (
                    <div
                        key={index}
                        className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                    >
                        <div className="flex items-center gap-3">
                            <div className="bg-blue-100 p-2 rounded-lg">
                                <FileText size={20} className="text-blue-600" />
                            </div>
                            <div>
                                <p className="font-medium">{file.name}</p>
                                <p className="text-sm text-gray-500">{file.size}</p>
                            </div>
                        </div>
                        <a
                            href={file.url}
                            download
                            className="p-2 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
                        >
                            <Download size={20} />
                        </a>
                    </div>
                ))}
            </div>
        </SectionContainer>
    );
};
